"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lowerInterest = exports.lowerInterestFormatted = exports.lowerInterestAsNumber = exports.interestDiff = exports.centralBankInterestRate = exports.centralBankInterestRateFormatted = exports.centralBankInterestRateAsNumber = void 0;
const folio_common_utils_1 = require("folio-common-utils");
exports.centralBankInterestRateAsNumber = 4.5;
exports.centralBankInterestRateFormatted = folio_common_utils_1.formatters.formatPercentage(exports.centralBankInterestRateAsNumber);
exports.centralBankInterestRate = exports.centralBankInterestRateAsNumber.toString();
exports.interestDiff = 0.75;
exports.lowerInterestAsNumber = exports.centralBankInterestRateAsNumber - exports.interestDiff;
exports.lowerInterestFormatted = folio_common_utils_1.formatters.formatPercentage(exports.lowerInterestAsNumber);
exports.lowerInterest = exports.lowerInterestAsNumber.toString();
//# sourceMappingURL=index.js.map